module.exports = __webpack_public_path__ + "static/media/iphone-mindfresh.feae0b3b.png";